export enum Cards {
    RunModel = "Run Model",
    VisualiseData = "Visualise and export data"
}
